module.exports = __webpack_public_path__ + "static/media/galaxy_transparent_2@2x.784df8ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/usecase-steak/assets/galaxy_transparent_2@2x.png
// module id = 58
// module chunks = 0